import e from "./_assocIndexOf.js";
function d(s, i) {
  var t = this.__data__, a = e(t, s);
  return a < 0 ? (++this.size, t.push([s, i])) : t[a][1] = i, this;
}
export {
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_listCacheSet.js
// module id = 1532
// module chunks = 67